module.exports = "/images/landslide@3x.png?d7b55fa9efaf887481d58e26935a73b4";